import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import QhRelatorioLinha from "@/model/qh/QhRelatorioLinha";
export default {
  listarLinhasPorPlano(idPlano) {
    return baseService
      .get("/api/qh-relatorios", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhRelatorioLinha(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar relatório do plano", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  gerarPlanoPdf(idPlano) {
    return baseService
      .get("/api/qh-relatorios/plano/pdf", {
        responseType: "blob",
        params: { idPlano: idPlano }
      })
      .then(response => {
        if (response) {
          this._criarLinkDownload("Relatorio Quadro Horario - Plano.pdf", response);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar gerar o relatório do plano", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  gerarFuncionarioPdf(idPlano, idPrevisao, nome) {
    return baseService
      .get("/api/qh-relatorios/funcionario/pdf/" + idPrevisao, {
        responseType: "blob",
        params: { idPlano: idPlano }
      })
      .then(response => {
        if (response) {
          this._criarLinkDownload("Relatorio Quadro Horario - " + (nome || "Funcionario") + ".pdf", response);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar gerar o relatório individual", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  _criarLinkDownload(nome, response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", nome);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
};
